// Single source of truth for carrier-form signing readiness, used by:
// - the enrollment signing view (client/src/lib/formReadiness.ts)
// - the plan-form attach routes, which reject unprepared carrier forms

// Carrier-form statuses that mean the form was never successfully prepared.
export const UNPREPARED_FORM_STATUSES = new Set([
  "analysis_failed",
  "uploaded",
  "analyzing",
]);

/**
 * True when a carrier form can't be safely signed: an explicit unprepared
 * status, or zero detected fields (a mapped/analyzed form can legitimately
 * lack a signature field, but one with *no fields at all* was never prepared).
 */
export function isCarrierFormUnprepared(
  status: string | null | undefined,
  fieldCount: number,
): boolean {
  if (UNPREPARED_FORM_STATUSES.has(String(status ?? "").toLowerCase())) return true;
  return fieldCount === 0;
}
